<template>
  <section>
    <div class="col-md-12 col-sm-1">
      <multi-select v-model="setdata" tag-placeholder="จังหวัด" :custom-label="nameWithLang"
                    placeholder="จังหวัด" label="name" track-by="province_name"  :options="data"
                    @input="update" style="font-size: 12px"
      ></multi-select>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "province",
  data(){
    return{
      data:[],
      setdata:[],
    }
  },
  props: {
    remove: {
      type: Array,
      default: () => []
    },
    editProvince: {
    // type: String | Number | Boolean | Object | {Number, String, Object},
      type: String,
      default: ''
      // type: String
    },
  },
  watch: {
    remove: function() {
      this.setdata = []
    },
    editProvince:function () {
      let data = {
        'province_name' : this.editProvince
      }
      axios.post('api/sysdata/findProvince',data)
          .then(response => {
            // console.log(response.data)
            this.setdata = response.data
          });
    }
  },
  computed:{

  },
  mounted(){
    this.getResults()
  },
  methods:{
    async getResults(){
      await axios.get('api/sysdata/getProvince')
          .then(response => {
            this.data =response.data
            // this.setdata = response.data[185]
            // this.$emit("SetData", this.setdata.district_name);
          });
    },

    nameWithLang({province_name}){
      return `${province_name}`
    },

    update(data){
      if (data != null) {
        this.$emit("SetData", data.province_name);
      }
    },

  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
